import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { LoginScreen } from './components/LoginScreen';
import { AppShell } from './components/AppShell';
import { useOfficeHost } from './hooks/useOfficeHost';
import { getCurrentAuthUser, type AuthUser } from './api/auth';

const BRAND = import.meta.env.VITE_BRAND_NAME || 'AgentCore';

export function App() {
  const { host, ready, inOffice } = useOfficeHost();
  const [user, setUser] = useState<AuthUser | null>(null);
  const [bootstrapping, setBootstrapping] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getCurrentAuthUser().then((u) => {
      if (!cancelled) {
        setUser(u);
        setBootstrapping(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready || bootstrapping) {
    return (
      <div className="flex h-full items-center justify-center text-ink-500">
        <Loader2 className="mr-2 h-4 w-4 animate-spin" /> Connecting to {BRAND}…
      </div>
    );
  }

  if (!user) {
    return <LoginScreen brand={BRAND} onSignedIn={setUser} />;
  }

  return (
    <AppShell
      brand={BRAND}
      host={inOffice ? host : (host === 'Teams' || host === 'Meet' ? host : 'Unknown')}
      user={user}
      onSignedOut={() => setUser(null)}
    />
  );
}
